import {
  ALERTAS_ERROR,
  ALERTAS_LOADING,
  ALERTAS_SUCCESS,
  ALERTAS_RESET,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetAlertas = () => (dispatch) => {
  dispatch({
    type: ALERTAS_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/alerta`)
      .then((res) => {
        dispatch({
          type: ALERTAS_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ALERTAS_ERROR,
          payload: error,
        });
      });
  });
};

export const wsLimpiarAlertas = () => (dispatch) => {
  dispatch({
    type: ALERTAS_RESET,
  });
};
